import {
    postFilesProviderLoading,
    postFilesProviderRequest,
    postFilesProviderSuccess,
    postFilesProviderReject,
    postFilesProviderReset
} from "../../actions/filesProvider/post";

export const postFilesProvider = (formData) => async (dispatch, getState) => {
    dispatch(postFilesProviderLoading());
    try {
        const { data } = await postFilesProviderRequest(formData, getState);
        dispatch(postFilesProviderSuccess(data))
    } catch (error) {
        dispatch(postFilesProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(postFilesProviderReset()) }, 3000);
    }
    return Promise.resolve();
};